import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dispatch } from "redux";

import { datadogRum } from "@datadog/browser-rum";
import { getTimings, setTiming } from "@src/store/slices/global";

const mark = (page: string, key: string, dispatch: Dispatch<any>) => {
  const value = performance.now();
  dispatch(setTiming({ key: page, value }));

  datadogRum.addAction(key, {
    timing: value,
  });

  console.log(`Timing: ${key} - ${value}`);
};

export const useRouteTiming = (options: {
  page: "init" | "home" | "experiences";
  isReady: boolean;
}) => {
  const dispatch = useDispatch();
  const timings = useSelector(getTimings());

  useEffect(() => {
    const pageKey = `${options.page}PageLoaded`;

    if (!options.isReady) {
      return;
    }

    if (options.page === "init") {
      mark(options.page, "appStarted", dispatch);
      datadogRum.addTiming("appStarted");
      return;
    }

    // tracking that the page is ready using datadog's timing metrics
    datadogRum.addTiming(pageKey);

    // else add in our timings based on performance.now
    if (!timings.initialPath) {
      return;
    }

    if (timings.initialPath !== `/${options.page}`) {
      return;
    }

    if (options.page in timings.timings) {
      return;
    }

    mark(options.page, pageKey, dispatch);
  }, [timings.initialPath, options.isReady, options.page]);
};
